export default "__VITE_ASSET__Cq3bg8rI__"